import { motion } from "framer-motion";
import { Sparkle } from "lucide-react";

const items = [
  "Mais disposição para o dia a dia",
  "Redução da compulsão alimentar",
  "Melhor qualidade do sono",
  "Mais confiança com o próprio corpo",
  "Resultados sustentáveis",
  "Relação mais saudável com a alimentação",
];

const CDN =
  "https://customer-assets-eiarnc6j.emergentagent.net/job_metodo-mariana/artifacts";

const screenshots = [
  `${CDN}/xoei51ix_PHOTO-2026-02-18-15-22-39%20%281%29.jpg`,
  `${CDN}/n8qb1zns_PHOTO-2026-02-18-15-22-39%20%283%29.jpg`,
  `${CDN}/rar6fpey_PHOTO-2026-02-18-15-22-39%20%282%29.jpg`,
  `${CDN}/e927bdxb_PHOTO-2026-02-18-15-22-39%20%285%29.jpg`,
  `${CDN}/w1u3rilo_PHOTO-2026-02-18-15-22-39%20%284%29.jpg`,
];

const Testimonials = () => {
  return (
    <section
      id="depoimentos"
      className="bg-[#F5EFE6]/40 py-20 md:py-32"
      data-testid="testimonials-section"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="mb-14 max-w-3xl"
        >
          <p className="mb-3 text-xs uppercase tracking-[0.3em] text-[#D4AF37]">
            Prova social
          </p>
          <h2
            className="font-serif text-3xl leading-tight text-[#3E2723] sm:text-4xl lg:text-5xl gold-line"
            data-testid="testimonials-title"
          >
            O que minhas pacientes <em className="italic">costumam relatar</em>
          </h2>
        </motion.div>

        <div className="mb-16 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {items.map((item, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{
                duration: 0.5,
                delay: i * 0.06,
                ease: [0.16, 1, 0.3, 1],
              }}
              className="flex items-center gap-3 rounded-2xl bg-white px-5 py-4 shadow-sm"
              data-testid={`relate-item-${i}`}
            >
              <Sparkle className="h-4 w-4 flex-shrink-0 text-[#D4AF37]" />
              <span className="text-sm text-[#3E2723] md:text-base">
                {item}
              </span>
            </motion.div>
          ))}
        </div>

        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {screenshots.map((src, i) => (
            <motion.figure
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{
                duration: 0.7,
                delay: i * 0.1,
                ease: [0.16, 1, 0.3, 1],
              }}
              className="overflow-hidden rounded-3xl border border-[#EFEBE1] bg-white p-3 shadow-[0_8px_30px_rgba(62,39,35,0.06)] transition-all hover:-translate-y-1 hover:shadow-[0_20px_40px_rgba(212,175,55,0.12)]"
              data-testid={`testimonial-${i}`}
            >
              <img
                src={src}
                alt={`Depoimento de paciente da Dra. Mariana Alves ${i + 1}`}
                loading="lazy"
                className="w-full rounded-2xl object-cover"
              />
            </motion.figure>
          ))}
        </div>

        <p className="mt-8 text-center text-xs italic text-[#795548]">
          * Depoimentos reais de pacientes, compartilhados com autorização.
        </p>
      </div>
    </section>
  );
};

export default Testimonials;
